<template>
	<v-navigation-drawer
		v-model="drawer"
		v-if="user.logged"
		:mini-variant.sync="mini"
		floating
		hide-overlay
		stateless
		dark
		class="blue-grey darken-4"
		app>

		
			<v-list class="pa-0">
				<v-list-item
					class="py-2"
					@click.stop="mini = !mini">
					<v-list-item-avatar class="mb-0"
					>
						<v-tooltip right v-if='mini'>
							<template v-slot:activator="{ on }">
								<Gravatar v-on="on" :email="user.email" alt="User" />
							</template>
							<span>Expandir</span>
						</v-tooltip>
						<Gravatar v-else :email="user.email" alt="User" />
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>{{ user.nickname }}</v-list-item-title>
					</v-list-item-content>

					<v-list-item-action class="ma-0">
						<v-tooltip right>
							<template v-slot:activator="{ on }">
								<v-icon v-on="on">{{miniIcon}}</v-icon>
							</template>
							<span>Recolher</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
		
		<v-list class="pt-0" dense>
			<v-divider></v-divider>
		
			<v-list-item
				@click.prevent="logout"
				>
				<v-list-item-action>
					<v-tooltip right v-if='mini'>
						<template v-slot:activator="{ on }">
							<v-icon v-on="on">mdi-account-arrow-right</v-icon>
						</template>
						<span>Sair</span>
					</v-tooltip>
					<v-icon v-else>mdi-account-arrow-right</v-icon>
				</v-list-item-action>
				<v-list-item-content>
					<v-list-item-title>Sair</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			
			<v-divider></v-divider>
			
			<v-list-item
			v-for="item in items"
			:key="item.title"
			:to="item.click"
			color="indigo lighten-5"
			>
				<v-list-item-action>
					<v-tooltip right v-if='mini'>
						<template v-slot:activator="{ on }">
							<v-icon v-on="on">{{ item.icon }}</v-icon>
						</template>
						<span>{{ item.title }}</span>
					</v-tooltip>
					<v-icon v-else>{{ item.icon }}</v-icon>
				</v-list-item-action>

				<v-list-item-content>
					<v-list-item-title>{{ item.title }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import { userKey } from '@/global'
import Gravatar from 'vue-gravatar'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('parameters')

export default {
    data () {
        return {
			drawer: true,
            items: [
                { title: 'Home', icon: 'mdi-view-dashboard', click: "/" },
                { title: 'Downloads', icon: 'mdi-cloud-download', click: "/downloads" },
                { title: 'Consultoria', icon: 'mdi-file-account', click: "/consult" },
                { title: 'Pesquisas', icon: 'mdi-file-alert', click: "/researches/treports" },
                { title: 'Administrador', icon: 'mdi-cogs', click: "/admin" },
                // { title: 'Logs', icon: 'mdi-alert', click: "/logs" },
            ],
			mini: true,
			miniIcon: 'mdi-chevron-right',
            right: null
        }
	},
	components: { Gravatar },
    computed: mapGetters(['user']),
    methods: {
        logout() {
            localStorage.removeItem(userKey)
            this.$store.commit('parameters/setUser', null)
            this.$router.push({ name: 'auth' })
		},
	},
	watch: {
		mini(val) {
			this.miniIcon = (val) ? 'mdi-chevron-right' : 'mdi-chevron-left'
		}
	},
	created() {
		// setTimeout(() => {
		// 	console.log(this.mini)
		// 	this.mini = true
		// }, 3000)  
	}
}
</script>

<style>
</style>